/*
 * Copyright (c) 2018-2023 MemberCenter, a subsidiary of Cameron Collective
 *   All Rights Reserved
 */
import BoldIcon from '@mui/icons-material/FormatBold';
import ItalicIcon from '@mui/icons-material/FormatItalic';
import UnderlineIcon from '@mui/icons-material/FormatUnderlined';
import Box from '@mui/material/Box';
import { Component } from 'react';

import InlineOption from './inline.option.component';
import { styles } from './styles';

const options = [
	{
		value: 'bold',
		icon: BoldIcon
	},
	{
		value: 'italic',
		icon: ItalicIcon
	},
	{
		value: 'underline',
		icon: UnderlineIcon
	}
];

class Inline extends Component {
	render() {
		const { currentState, onChange } = this.props;
		return (
			<Box sx={styles.root}>
				{options.map((item, index) => {
					return (
						<InlineOption
							key={index}
							icon={item.icon}
							onClick={onChange}
							value={item.value}
							active={currentState[item.value]}
						/>
					);
				})}
			</Box>
		);
	}
}

export default Inline;
